export const modalsStateSetDictKeys = {
    deleteCustomerJourney: 'deleteCustomerJourney',
    editCustomerJourney: 'editCustomerJourney',
    archiveCustomerJourney: 'archiveCustomerJourney',
    unarchiveCustomerJourney: 'unarchiveCustomerJourney',
    stopSendCustomerJourney: 'stopSendCustomerJourney',
    startCustomerJourney: 'startCustomerJourney',
    resumeCustomerJourney: 'resumeCustomerJourney',
    infoCustomerJourney: 'infoCustomerJourney',
    makePublicCustomerJourney: 'makePublicCustomerJourney',
    makePrivateCustomerJourney: 'makePrivateCustomerJourney',
} as const;
